export default "__VITE_ASSET__DIwT3y3Z__"